export default class List {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  list = [];

  constructor(list) {
    this.list = list;
  }
  updateList(list){
    this.list = list;
  }
}
